import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';

export function runApp() {
  const { store, httpApi, logger } = createApplicationState();

  renderApplication({ store, httpApi, logger });
}
